export default __webpack_public_path__ + "static/media/413.c5f2d158.png";